export default {
	setFoo (state, value) {
		state.foo = value
	},
	setNetwork (state, value) {
		state.network = value
	},
	setAccount (state, value) {
		state.account = value
	},
	setTokenInfo (state, value) {
		state.tokenInfo = value
	},
	setRelayerInfo (state, value) {
		state.relayerInfo = value
	}
}